import ApplicationController from '@aha-app/mvc';
import AssistantChat from '../../../framework/models/AssistantChat';

export interface HistoryProps {}

interface HistoryState {
  // Current search query.
  query?: string;
  // Loaded chats in time order.
  chats: AssistantChat[];
  // Whether to show the search results.
  showSearchResults: boolean;
  // If there are more chats to load.
  hasMore: boolean;
  // The page of chats currently loaded.
  currentPage: number;
}

export class HistoryController extends ApplicationController<
  HistoryState,
  HistoryProps
> {
  static initialState = {
    hasMore: true,
    chats: [],
    showSearchResults: false,
    currentPage: 0,
  };

  // When showing the search results, we store the loaded chats to the side
  // so we can reinstate them instantly.
  chatTemp: AssistantChat[] = [];
  hasMoreTemp: boolean = false;
  currentPageTemp: number = 0;

  // Whether are currently loading data, so we don't reenter.
  loading: boolean = false;

  async initialize(_props: HistoryProps) {
    this.actionLoadMoreChats();
  }

  // Load a page of chats.
  async actionLoadMoreChats() {
    if (!this.state.hasMore || this.loading) return;

    try {
      this.loading = true;
      let query = await AssistantChat.select([
        'id',
        'name',
        'updatedAt',
        'creditCost',
      ])
        .order({ updatedAt: 'DESC' })
        .per(20)
        .page(++this.state.currentPage)
        .stats(['isLastPage']);

      if (this.state.showSearchResults) {
        query = query.whereMerge({ query: this.state.query });
      }
      const newChats = await query.all();
      newChats.map(chat => this.state.chats.push(chat));
      this.state.hasMore = !newChats.isLastPage;
    } finally {
      this.loading = false;
    }
  }

  // Search chats.
  actionSearchChats(query: string) {
    if (this.state.showSearchResults && query.length > 0) {
      // Reset the existing search.
      this.state.query = query;
      this.state.chats = [];
      this.state.hasMore = true;
      this.state.currentPage = 0;
      this.actionLoadMoreChats();
      return;
    }

    if (query.length > 0) {
      this.chatTemp = this.state.chats;
      this.hasMoreTemp = this.state.hasMore;
      this.currentPageTemp = this.state.currentPage;

      this.state.chats = [];
      this.state.hasMore = true;
      this.state.currentPage = 0;
      this.state.query = query;
      this.state.showSearchResults = true;

      this.actionLoadMoreChats();
    } else {
      // Stop searching.
      this.state.showSearchResults = false;
      this.state.chats = this.chatTemp;
      this.state.hasMore = this.hasMoreTemp;
      this.state.currentPage = this.currentPageTemp;
      this.state.query = '';
    }
  }

  actionDeleteChat(chat: AssistantChat) {
    void chat.destroy();
    this.state.chats = this.state.chats.filter(c => c.id !== chat.id);
  }
}

export default HistoryController;
